import { useHttpClient } from '@/common/api/httpClient';
import { createMapStyle } from 'shared/mapStyles/domain/createMapStyle';
import { useMapStyleStore } from 'shared/mapStyles/stores/mapStyleStore';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { MapStyleResponse } from 'shared/mapStyles/api/mapStyleResponse';

export interface UpdateMapStyleRequest {
  styleId: string;
  style: MapStyle;
}

export interface MapStyle {
  name?: string;

  shapeLabelFormula?: string | null;
  shapeColorFormula?: string | null;
  shapeOutlineColorFormula?: string | null;
  shapeOutlineSizeFormula?: string | null;
  shapeFontSizeFormula?: string | null;
  shapeMessageIconFormula?: string | null;

  vehicleColorFormula?: string | null;

  placeVisibleFormula?: string | null;
  placeLabelFormula?: string | null;
  placeOutlineColorFormula?: string | null;
  placeOutlineSizeFormula?: string | null;
  placeAccessibleOutlineColorFormula?: string | null;
  placeInaccessibleOutlineColorFormula?: string | null;
  placeTextAlignmentFormula?: string | null;
  placeTextPositionFormula?: string | null;
  placeTextOpacityFormula?: string | null;
  placeTextColorFormula?: string | null;
  placeTextSizeFormula?: string | null;
  placeBackgroundColorFormula?: string | null;
  placeBackgroundPatternFormula?: string | null;
  placeBackgroundOpacityFormula?: string | null;

  packageVisibleFormula?: string | null;
  packageLabelFormula?: string | null;
  packageOutlineColorFormula?: string | null;
  packageOutlineSizeFormula?: string | null;
  packageTextAlignmentFormula?: string | null;
  packageTextPositionFormula?: string | null;
  packageTextOpacityFormula?: string | null;
  packageTextColorFormula?: string | null;
  packageTextSizeFormula?: string | null;
  packageBackgroundColorFormula?: string | null;
  packageBackgroundPatternFormula?: string | null;
  packageBackgroundOpacityFormula?: string | null;
  proximityVisibleFormula?: string | null;
  proximityAreaColorFormula?: string | null;
  proximityConeColorFormula?: string | null;
}

export interface UpdateMapStyleResponse {
  style: MapStyleResponse;
}

export function useUpdateMapStyle() {
  const httpClient = useHttpClient();
  const store = useMapStyleStore();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UpdateMapStyleRequest) {
    const {
      style,
      styleId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`mapStyle/${styleId}`), {
      method: 'PUT',
      headers,
      body: JSON.stringify(style)
    });

    const text = translations.value.mapStyles.actions.update;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as UpdateMapStyleResponse;
        return {
          ok: true,
          style: json.style
        };
      },
    });

    if (response.ok) {
      const style = createMapStyle({
        style: response.style
      }).mapStyle;

      store.merge(style);
    }

    return response;
  }
}


